import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/classes";

/* Variants */
const variants = cva("btn min-h-10 h-10 max-h-10 no-animation rounded-lg shadow-none border-none", {
  variants: {
    variant: {
      primary: "btn-primary",
      secondary: "btn-secondary",
      error: "btn-error",
      ghost: "btn-ghost hover:bg-base-100",
      gradient: "bg-primary-gradient text-white!",
    },
    align: {
      left: "text-left",
      right: "text-right",
      center: "text-center",
    },
    loading: {
      true: "cursor-progress",
      false: "",
    },
    selected: {
      true: "bg-primary text-primary-content hover:bg-primary",
      false: "",
    },
  },
  defaultVariants: {
    align: "center",
  },
});

/* Prop Types */
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variants> {}

/*
 * Button Component
 */
export const Button = ({ className, variant, selected, children, loading, ...props }: ButtonProps) => {
  return (
    <button {...props} className={cn(variants({ variant, className, selected }))}>
      {!loading && children}
    </button>
  );
};
